import { Currency } from '@/core/currency/interfaces';

const CUP: Currency = {
    name: 'Cuban Peso',
    demonym: 'Cuban',
    majorSingle: 'Peso',
    majorPlural: 'Pesos',
    codeNumeric: '192',
    symbol: '$MN',
    symbolNative: '₱',
    minorSingle: 'Centavo',
    minorPlural: 'Centavos',
    ISOdigits: 2,
    decimals: 2,
    numToBasic: 100,
    code: 'CUP',
    delimiters: {
        thousands: '.',
        decimal: ','
    }
};

export default CUP;
